import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { TicketDto } from '../models/Tickets/TicketDto';
import { ResponseBase } from '../models/ResponseBase';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TicketService {

  constructor(private httpService: HttpService) { }

  createTicket(ticketData: TicketDto ) {
    return this.httpService.post<ResponseBase>('Tickets/v1/CreateTicket', ticketData);
  }

  updateTicket(ticketData: TicketDto) {
    return this.httpService.put<ResponseBase>(`Tickets/v1/updateTicket`, ticketData);
  }

  // getTicketById(ticketId: string) {
  //   return this.httpService.get(`/api/tickets/${ticketId}`);
  // }

  getAllTickets() {
    return this.httpService.get<TicketDto[]>('Tickets/v1/getAllTickets').pipe(tap((data) => {}));
  }

  getTicketById(id: number) {
    return this.httpService.get<TicketDto>('Tickets/v1/getTicketById/'+ id).pipe(tap((data) => {}));
  }

  getTicketsStatuses() {
    return this.httpService.get<string[]>('Tickets/v1/getTicketsStatuses').pipe(tap((data) => {}));
  }

  archiveTicket(ticketId?: number) {
    return this.httpService.delete<ResponseBase>(`Tickets/v1/archiveTicket/${ticketId}`).pipe(tap((data) => {}));
  }
}
